import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import GradientBtn from "../GradientBtn";
import HealthProfileImage from "src/assets/images/website-images/mobile-health-profile-mock.png";
import { RootState } from "src/Store/store";
import { useSelector } from "react-redux";

const HealthProfileSection = () => {
  let List = [
    [
      "Accurate Results:",
      "Ensure precise and reliable outcomes for all your health concerns.",
    ],
    [
      "Wide Range of Tests:",
      "From basic screenings to specialized diagnostics, we've got you covered.",
    ],
    [
      "Fast Turnaround Time:",
      "Get your detailed health reports quickly and efficiently.",
    ],
    [
      "Expert Review:",
      "All tests are analyzed by certified medical professionals.",
    ],
  ];

  let { isLogged } = useSelector((state: RootState) => state.appReducer);

  return (
    <div className="w-full py-5" data-aos="fade-up" data-aos-duration="800">
      <div className="view-area-width mx-auto">
        <div className="w-full flex flex-col md:flex-row justify-between md:items-center">
          <div
            className="w-full md:w-[45%] flex flex-col gap-4 xl:gap-6 2xl:gap-8 "
          >
            <h2 className="font-Lexend-SemiBold font-size-62px text-[#00443F] leading-none">
              Health Profile
            </h2>
            <div className="w-full flex flex-col gap-4 xl:gap-6 2xl:gap-8 ">
              {List.map((item, index) => (
                <div
                  key={index}
                  className="flex gap-2"
                >
                  <div className="w-[15px] h-[15px] xl:w-[20px] xl:h-[20px] bg-[#00443F] mt-1 rounded-full flex items-center justify-center">
                    <FontAwesomeIcon
                      icon={faCheck}
                      size="xs"
                      className="text-white font-size-12px"
                    />
                  </div>
                  <p className="font-Lexend-Medium font-size-18px text-[#3B3B3B] w-[calc(100%-20px)]">
                    <span className="font-Lexend-SemiBold font-size-20px">
                      {item[0]}
                    </span>{" "}
                    {item[1]}
                  </p>
                </div>
              ))}
            </div>
            <div className="flex mt-2.5 xl:mt-4 2xl:mt-5">
              {!isLogged ? (
                <GradientBtn
                  fontsizeBtn="font-size-18px"
                  fontfamilyBtn="font-Lexend-SemiBold"
                  ButtonText="Join now"
                  onPress={() => {
                    let ele = document.getElementById(
                      "account-btn"
                    ) as HTMLButtonElement;
                    if (ele && ele.click && !isLogged) {
                      ele.click();
                    }
                  }}
                />
              ) : null}
            </div>
          </div>
          <div
            className="w-full md:w-[45%]"
            data-aos="fade-left"
            data-aos-delay="300"
            data-aos-duration="800"
          >
            <img
              src={HealthProfileImage}
              alt="HealthProfileImage"
              className="w-full object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HealthProfileSection;
